import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import { Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function DriversAdd() {
    const navigate = useNavigate();    
    const [exitLocations, setExitLocations] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact_number: '',
        exit_location_ids: [],
        is_active: true,
        pin: ''
    });    
    
    useEffect(() => {
        fetchExitLocations();
    }, []);

    const fetchExitLocations = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/active-exit-locations', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setExitLocations(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading parking lots');
        }
    };   
    
    const handleInputChange = (e) => {
        const { name, value, type, checked, selectedOptions } = e.target;
        if (name === 'exit_location_ids' && selectedOptions) {
            const selectedValues = Array.from(selectedOptions).map(option => option.value);
            setFormData(prev => ({
                ...prev,
                [name]: selectedValues
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
    }};

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = {
                ...formData,
                is_active: Boolean(formData.is_active) // Ensure boolean
            };
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/drivers', data,{
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Driver added successfully');
            navigate('/accounts/drivers-list');
        } catch (error) {
            console.error('Error:', error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Failed to add driver');
            }
        }
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Add Driver" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Full Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                placeholder="Enter email address"
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Contact Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contact_number"
                                                value={formData.contact_number}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Valet Locations</Form.Label>
                                            <Select
                                                isMulti
                                                name="exit_location_ids"
                                                options={exitLocations.map(location => ({
                                                    value: location.id,
                                                    label: location.name
                                                }))}
                                                value={exitLocations
                                                    .filter(location => formData.exit_location_ids.includes(location.id))
                                                    .map(location => ({
                                                        value: location.id,
                                                        label: location.name
                                                    }))}
                                                onChange={(selectedOptions) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        exit_location_ids: selectedOptions ? selectedOptions.map(option => option.value) : []
                                                    }));
                                                }}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select locations..."
                                                isClearable
                                                isSearchable
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
                                                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
                                                        '&:hover': {
                                                            borderColor: state.isFocused ? '#80bdff' : '#adb5bd'
                                                        },
                                                        borderRadius: '0.375rem',
                                                        minHeight: '42px'
                                                    }),
                                                    multiValue: (styles) => ({
                                                        ...styles,
                                                        backgroundColor: '#e7f5ff',
                                                        borderRadius: '4px',
                                                        padding: '2px'
                                                    }),
                                                    multiValueLabel: (styles) => ({
                                                        ...styles,
                                                        color: '#0066cc',
                                                        fontSize: '0.9em',
                                                        fontWeight: 500
                                                    }),
                                                    multiValueRemove: (styles) => ({
                                                        ...styles,
                                                        color: '#0066cc',
                                                        ':hover': {
                                                            backgroundColor: '#0066cc',
                                                            color: 'white',
                                                        },
                                                        borderRadius: '0 4px 4px 0'
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => ({
                                                        ...styles,
                                                        backgroundColor: isSelected ? '#0066cc' : isFocused ? '#e7f5ff' : null,
                                                        color: isSelected ? 'white' : '#333',
                                                        cursor: isDisabled ? 'not-allowed' : 'default',
                                                        ':active': {
                                                            backgroundColor: !isDisabled
                                                                ? isSelected ? '#0066cc' : '#b3d7ff'
                                                                : undefined
                                                        }
                                                    }),
                                                    menu: (styles) => ({
                                                        ...styles,
                                                        borderRadius: '0.375rem',
                                                        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                                        marginTop: '4px'
                                                    }),
                                                    placeholder: (styles) => ({
                                                        ...styles,
                                                        color: '#6c757d'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>PIN Code</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="pin"
                                                value={formData.pin}
                                                onChange={handleInputChange}
                                                required
                                                minLength={4}
                                                maxLength={6}
                                                pattern="[0-9]*"
                                                inputMode="numeric"
                                                placeholder="Enter 4-6 digit PIN"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                label="Active Status"
                                                name="is_active"
                                                checked={formData.is_active}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Button type="submit" variant="primary">
                                            Add Driver
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DriversAdd;